<template>
    <edit-resource
        :title="title"
        :form="form"
        @close="$emit('close')"
        @submit="saveStage"
        single-button
    >

        <div class="min-w-400">

            <simple-input v-model="form.name" class="mb-24">
                {{ $t('settings.email-templates.name') }}
            </simple-input>

            <toggle v-model="form.onboarding">{{ $t('stages.enable_onboarding') }}</toggle>
        </div>

    </edit-resource>
</template>

<script>
import EditResource from './EditResource.vue';
import Input from '../forms/Input.vue';
import Form from '../../etc/forms/Form';
import * as stageService from '../../services/StageService';
import SimpleButton from '../../components/ui/SimpleButton.vue';
import Stage from '../../models/Stage';
import { normalizeJson } from '../../../shared/helpers';
import Toggle from '../forms/Toggle.vue';
import {useRepo} from 'pinia-orm';
import {useMax} from 'pinia-orm/helpers';

function getFields () {
    return [
        { name: 'name', value: '' },
        { name: 'onboarding', value: false },
    ];
}

export default {
    components: {
        'edit-resource': EditResource,
        'simple-button': SimpleButton,
        'simple-input': Input,
        'toggle': Toggle,
    },
    props: {
        stage: Object,
        job: Object,
    },
    data: function () {
        return {
            form: this.generateForm(),
            savingStage: false,
        }
    },
    computed: {
        title () {
            return this.$t(this.stage ? 'general.edit_subject' : 'general.add_subject', { subject: this.$t('stages.stage') })
        }
    },
    methods: {
        generateForm () {

            let fields = getFields();

            if (this.stage) {
                fields.forEach((field, index) => {
                    fields[index].value = JSON.parse(JSON.stringify(this.stage[field.name]));
                });
            }

            return new Form(fields);
        },

        async saveStage () {
            if (this.stage) {
                await this.updateStage();
            } else {
                await this.createStage();
            }

            this.$emit('close');
        },
        updateStage () {
            return this.form.submit(data => stageService.update(this.stage.id, {
                data: { attributes: data },
            })).then(result => {
                const data = normalizeJson(result);
                return useRepo(Stage).save({
                    id: data.id,
                    name: data.name,
                    onboarding: data.onboarding,
                });
            });
        },
        createStage () {
            const stages = useRepo(Stage).where('job_id', this.job.id).get();
            const nextOrder = useMax(stages, 'order') + 1;

            return this.form.submit(data => stageService.store(this.job.id, {
                data: { attributes: {
                    ...data,
                    order: nextOrder
                } },
            })).then(result => {
                return useRepo(Stage).save(normalizeJson(result));
            }).then(inserts => {
                let newStage = inserts;
                const data = useRepo(Stage)
                    .where('job_id', newStage.job_id)
                    .get()
                    .map((item) => {
                        const order = item.id !== newStage.id && item.order >= newStage.order ? item.order + 1 : item.order;
                        const siblingCount = item.id !== newStage.id ? item.sibling_count + 1 : item.sibling_count;
                        const applicationsCount = item.application_count ? this.application_count : 0;
                        return {
                            id: item.id,
                            order: order,
                            sibling_count: siblingCount,
                            applications_count: applicationsCount
                        }
                    });
                useRepo(Stage).save(data);
            });
        },
    }
}
</script>
